import { Component, OnInit, ViewEncapsulation, Input, OnChanges, Type, ViewChild, ElementRef, Inject, PLATFORM_ID, Injector } from '@angular/core';
import { AdType } from "../ads-banners/ads-banners.component";
import { UpaTarget } from "../../services/upa.service";
import { Module } from "../../model/ModuleModel";
import { ModuleService } from 'projects/common/services/module.service';
import { UtilsService } from 'projects/common/services/utils.service';
import { MediaPictureService } from 'projects/common/services/media-picture.service';

import { SliderOptions } from '../slider/slider/slider.component';
import { SliderProOptions } from '../slider-pro/slider-pro.component';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { EvaSize } from '@shopping-angular-components/loader';
import { BannerComponent } from './banner.component';
import { Banner } from './banner.component';
import { AbstractComponent } from '../abstract.component';

type MultiBannerModuleData = {
  cards: Banner[];
  slider_options?: SliderOptions;
  view_full_width?: boolean;
  infinite_scroll?: boolean;
  auto_scroll?: boolean;
}

@Component({
  selector: 'multi-banner',
  template: `

    <text *ngIf="module.pretitle?.text || module.title?.text || module.subtitle?.text" [data]="module"></text>

    <div *ngIf="!module.data.slider_options" class="multi-banner" [class]="['banners-' + bannersNumber]">
      <banner *ngFor="let banner of module.data.cards; let i = index"
                          [banner]="banner"
                          [index]="i"
                          [bannersNumber]="bannersNumber"
                          [bannersSize]="bannersSize"
                          [moduleId]="MODULE_ID"
                          [uniqueId]="module.unique_id"
                          [moduleIndex]="module.row_number"
                          [rounded]="!viewFullWidth"
                          [adBannerType]="getAdBannerTypeForIndex(banner, i)">
      </banner>
    </div>
    
    <div *ngIf="module.data.slider_options" #sliderContainer>
      <div *ngIf="!showSlider" class="loaders-container -eva-3-skeleton">
        <div class="-skeleton-text" [style]="{'height': device.type === 'MOBILE' ? MOBILE_MAX_FULL_BANNER_HEIGHT + 'px' : DESKTOP_MAX_FULL_BANNER_HEIGHT + 'px'}"></div>
      </div>

      <div *ngIf="showSlider" class="slider-wrapper" [ngClass]="{'slider-container': !viewFullWidth, '-above-ssr': this.isAboveTheFoldAB && this.isPlatformServer , 'is-full-width': viewFullWidth}">
        <slider-pro
          [options]="sliderProOptions"
          [componentParams]="componentParams"
          [components]="components"
          [upaData]="upaData"
          [viewFullWidth]="viewFullWidth"
          [useGaps]="device.type !== 'MOBILE'"
          [resizable]="false">
        </slider-pro>
      </div>
    </div>
  `,
  styleUrls: ['./multi-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MultiBannerComponent extends AbstractComponent implements OnInit, OnChanges {
  @Input() override module: Module<MultiBannerModuleData>;
  @Input() device: { type: string };
  @Input() override flow: string;

  // SLIDER
  @ViewChild("sliderContainer") public sliderContainer: ElementRef;
  showSlider = false;
  viewFullWidth = false; // TODO pasar a slider_options ?
  infiniteScroll = false; // TODO pasar a slider_options ?
  autoScroll = false; // TODO pasar a slider_options ?
  loaders: number[] = [];
  evaSizes = EvaSize;

  sliderProOptions: SliderProOptions;
  componentParams: any[] = [];
  components: Type<any>[] = [];
  upaData: any;

  MODULE_ID: string = "MultiBannerModule";
  bannerHomeDynamic1 = AdType.BANNER_HOME_DYNAMIC1;
  bannerHomeDynamic2 = AdType.BANNER_HOME_DYNAMIC2;

  isAboveTheFoldAB = false;
  isPlatformServer = false;

  private readonly MOBILE_FULL_BANNER_WIDTH = 360;
  private readonly MOBILE_FULL_BANNER_HEIGHT = 180;
  public readonly MOBILE_MAX_FULL_BANNER_HEIGHT = 212;
  private readonly DESKTOP_FULL_BANNER_WIDTH = 1280;
  private readonly DESKTOP_FULL_BANNER_HEIGHT = 338;
  public readonly DESKTOP_MAX_FULL_BANNER_HEIGHT = 338;

  fullAdTypes = {
    desktop: [
      AdType.BANNER_HOME_FULL1,
      AdType.BANNER_HOME_FULL2,
      AdType.BANNER_HOME_FULL3,
      AdType.BANNER_HOME_FULL4,
      AdType.BANNER_HOME_FULL5,
      AdType.BANNER_HOME_FULL6
    ],
    mobile: [
      AdType.BANNER_HOME_MOBILE_FULL1,
      AdType.BANNER_HOME_MOBILE_FULL2,
      AdType.BANNER_HOME_MOBILE_FULL3,
      AdType.BANNER_HOME_MOBILE_FULL4,
      AdType.BANNER_HOME_MOBILE_FULL5,
      AdType.BANNER_HOME_MOBILE_FULL6
    ]
  }

  bannersNumber: number;

  bannersSize: string[] = [''];
  mobileSizeList = {
    1: ["/382x270"],
    default: ["/375x345"]
  };
  desktopSizeList = {
    1: ["/1280x270"],
    2: ["/632x270", "/632x270"],
    3: ["/632x270", "/312x270", "/312x270"],
    default: ["/312x270"]
  };

  constructor(injector: Injector, public utils: UtilsService, private moduleService: ModuleService,
              public mediaService: MediaPictureService, @Inject(PLATFORM_ID) private platformId: string) {
    super(injector);
  }

  ngOnInit(): void {
    this.isAboveTheFoldAB = this.landingModelService.getLandingModel().abTests?.tests?.NymeriaAboveTheFold?.branch == 'test';
    this.initialize();
  }

  ngOnChanges(): void {
    this.initialize();
  }

  initialize(): void {
    this.isPlatformServer = isPlatformServer(this.platformId);
    this.bannersNumber = this.module.data.cards?.length;
    if (this.moduleService.isRestrictResources(this.MODULE_ID)) {
      const sizeList = this.device.type == 'MOBILE' ? this.mobileSizeList : this.desktopSizeList;
      this.bannersSize = sizeList[this.bannersNumber] || sizeList['default'];
    }
    if (this.isAboveTheFoldAB) {
      this.loaders = Array.from({ length: this.getItemsToShow() }, (_, i) => i);
      this.showSlider = true;
      this.initializeUpaData();
      this.initializeSlider();
    }
  }


  private initializeSlider(): void {
    this.viewFullWidth = this.module.data.view_full_width || false;
    this.infiniteScroll = this.module.data.slider_options?.infinite_scroll || false;
    this.autoScroll = this.module.data.slider_options?.auto_scroll || false;
    
    
    this.transformModelToSliderPro();
    
    this.initSliderProOptions();
  }

  private getItemsToShow(): number {
    return this.module.data.slider_options?.items_to_show ||
      (this.device.type === 'DESKTOP' ? this.bannersNumber : 1);
  }

  private initializeUpaData(): void {
    this.upaData = {
      uniqueId: this.module.unique_id,
      moduleId: this.module.id,
      moduleIndex: this.module.row_number,
      target: UpaTarget.BANNER
    };
  }

  private calculateBannersHeight(): number {
    const clientWidth = this.sliderContainer?.nativeElement?.clientWidth || 
      (isPlatformBrowser(this.platformId) ? document.documentElement.clientWidth : 1280);

    if (this.device.type === 'MOBILE') {
      const mobileHeight = Math.round((clientWidth * this.MOBILE_FULL_BANNER_HEIGHT) / this.MOBILE_FULL_BANNER_WIDTH);
      return Math.min(mobileHeight, this.MOBILE_MAX_FULL_BANNER_HEIGHT);
    } else {
      const desktopHeight = Math.round((clientWidth * this.DESKTOP_FULL_BANNER_HEIGHT) / this.DESKTOP_FULL_BANNER_WIDTH);
      return Math.min(desktopHeight, this.DESKTOP_MAX_FULL_BANNER_HEIGHT);
    }
  }

  private transformModelToSliderPro(): void {
    this.components = Array(this.module.data.cards.length).fill(BannerComponent);

    if (this.isAboveTheFoldAB && this.isPlatformServer && this.module.data?.cards?.length > 1) {
      this.components = Array(1).fill(BannerComponent);
    }

    const bannersHeight = this.isAboveTheFoldAB ? this.calculateBannersHeight() : undefined;

    this.componentParams = this.module.data.cards.map((banner, index) => ({
      uniqueId: this.module.unique_id,
      banner: banner,
      index: index,
      bannersNumber: this.bannersNumber,
      bannersSize: this.bannersSize,
      moduleId: this.MODULE_ID,
      moduleIndex: this.module.row_number,
      adBannerType: this.getAdBannerTypeForIndex(banner, index),
      hostCssClass: 'multi-banner',
      minHeight: bannersHeight,
      rounded: !this.viewFullWidth
    }));
  }

  private initSliderProOptions(): void {
    const isDesktop = this.device.type === 'DESKTOP';
    const isMobile = this.device.type === 'MOBILE';
    const itemsToShow = this.getItemsToShow();
    const itemsToMove = this.module.data.slider_options?.items_to_move ?? 1;
    const showArrows = this.module.data.slider_options?.show_arrows !== undefined ? this.module.data.slider_options?.show_arrows : isDesktop && !this.viewFullWidth;
    const showDots = this.module.data.slider_options?.show_dots !== undefined ? this.module.data.slider_options?.show_dots : isMobile || (isDesktop && !this.viewFullWidth);
    const useExtendedArrows = this.module.data.slider_options?.use_extended_arrows !== undefined ? this.module.data.slider_options?.use_extended_arrows : !isDesktop && showArrows;
    const width = this.sliderContainer?.nativeElement?.clientWidth || globalThis.innerWidth;
    const containerWidth = width > 1280 ? 1280 : width;

    this.sliderProOptions = {
      itemsToShow: { 'DEFAULT': itemsToShow },
      itemsToMove: { 'DEFAULT': itemsToMove },
      dragToMove: { 'DEFAULT': !isDesktop },
      showArrows: { 'DEFAULT': showArrows },
      showDots: { 'DEFAULT': showDots },
      dotsLighten: this.viewFullWidth,
      infiniteScroll: { 'DEFAULT': this.infiniteScroll },
      autoScroll: { 'DEFAULT': this.autoScroll },
      containerWidth: { 'DEFAULT': containerWidth },
      useExtendedArrows: { 'DEFAULT': useExtendedArrows },
      arrowsColor: { 'DEFAULT': isMobile ? '-negative' : '-white' },
    };
  }

  getAdBannerTypeForIndex(banner: Banner, index: number): AdType | undefined {
    // si tenemos slider_options es aboveTheFold y cualquier espacio puede ser AD
    if (this.isAboveTheFoldAB && banner.ad) {
      return this.fullAdTypes[this.device.type === 'MOBILE' ? 'mobile' : 'desktop'][index];
    }

    if (banner.ad) {
      if (index === this.bannersNumber - 2) return this.bannerHomeDynamic1;
      if (index === this.bannersNumber - 1) return this.bannerHomeDynamic2;
    }
  }

  getModuleId(): string {
    return this.MODULE_ID; 
  }
}
